import antdSA from 'antd/lib/locale-provider/ar_EG';
import appLocaleData from 'react-intl/locale-data/ar';
import saMessages from '../locales/ar_SA.json';
const saLang = {
  messages: {
    ...saMessages,
  },
  antd: antdSA,
  locale: 'ar',
  data: appLocaleData,
  direction: 'rtl',
};
export default saLang;
